import { render } from "./KeyBoardUI.vue?vue&type=template&id=5777df61"
import script from "./KeyBoardUI.vue?vue&type=script&lang=js"
export * from "./KeyBoardUI.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__